var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkbox_container" }, [
    _c("label", { staticClass: "customi_label", attrs: { for: _vm.namer } }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.checked,
            expression: "checked"
          }
        ],
        staticClass: "invisible customi_input",
        attrs: { type: "radio", name: _vm.namer },
        domProps: { checked: _vm._q(_vm.checked, null) },
        on: {
          change: function($event) {
            _vm.checked = null
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "customi_div radio" }, [
        _c(
          "svg",
          {
            staticClass: "customi_svg",
            attrs: { version: "1.1", id: "Layer_1", viewBox: "0 0 20 20" }
          },
          [
            _c("circle", {
              staticClass: "svg_bg",
              attrs: { cx: "10", cy: "10", r: "9" }
            }),
            _vm._v(" "),
            _c("circle", {
              staticClass: "svg_top radio_check",
              attrs: { cx: "10", cy: "10", r: "6" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.label))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Misc/Radio.vue?vue&type=template&id=0c0c8a60&
// module id = null
// module chunks = 